<template>
  <div>
    <el-menu :router="true" :default-active="$route.path" class="el-menu" mode="horizontal">
      <el-menu-item
        v-if="!isCatering && showButton"
        :class="['menu-item', { 'is-active': isMenuRoute }]"
        :accesskey="navigationAccessKeys.home"
        data-test-selector="menu-button"
        index="/menu"
      >
        {{ $t('navBar.menuButton') }}
      </el-menu-item>
      <el-menu-item
        v-if="showButton"
        :accesskey="navigationAccessKeys.settings"
        :index="settingsRoute"
        class="menu-item"
        data-test-selector="settings-button"
      >
        {{ $t('navBar.settingsButton') }}
      </el-menu-item>
      <el-menu-item
        v-if="showButton"
        :accesskey="navigationAccessKeys.reports"
        :index="reportsRoute"
        class="menu-item"
        data-test-selector="reports-button"
      >
        {{ $t('navBar.reportsButton') }}
      </el-menu-item>
      <el-menu-item
        v-if="isAdmin"
        :class="['menu-item', { 'is-active': isAdminRoute }]"
        index="/admin"
      >
        {{ $t('navBar.adminButton') }}
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  ADMIN_ROLE,
  ROUTE_NAMES,
  NAVIGATION_ACCESS_KEYS,
  CATERING_ROLE,
  ROUTES,
} from '@/constants';
import get from 'lodash.get';

export default {
  name: 'NavBar',
  data() {
    return {
      navigationAccessKeys: NAVIGATION_ACCESS_KEYS.navbar,
    };
  },
  computed: {
    ...mapGetters('user', { user: 'getUser' }),
    isAdmin() {
      return this.user.role === ADMIN_ROLE;
    },
    isCatering() {
      return this.user.role === CATERING_ROLE;
    },
    showButton() {
      // User.role is undefined until the user is completely initialized
      return this.user.role !== undefined;
    },
    isMenuRoute() {
      return this.$route.name === ROUTE_NAMES.WEEKLY_MENU;
    },
    isAdminRoute() {
      return this.$route.name === ROUTE_NAMES.ADMIN;
    },
    settingsRoute(prop) {
      const isCatering = get(prop, 'user.role', '') === CATERING_ROLE;
      if (isCatering) {
        return ROUTES.CATERING_SETTINGS;
      }
      return ROUTES.SETTINGS;
    },
    reportsRoute() {
      return ROUTES.REPORTS;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.el-menu {
  margin: -8px;
  left: 175px;
  padding: 0;
  position: absolute;
  background-color: transparent;
}

// overwrite theme-chalk selector from element-ui
.el-menu-item:not(.is-disabled):hover {
  background-color: transparent;
}

.menu-item {
  text-align: center;
}

.el-menu-item {
  &.menu-item {
    &.is-active {
      background-color: transparent !important;
      border-bottom: 2px solid #409eff !important;
    }
  }
}

.el-menu--horizontal {
  border-bottom: 0;
}

@media only screen and (max-width: 550px) {
  .menu-item {
    display: none; // hide for small screens, no settings or admin
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue